import { useLanguageHandler } from "./language.hook";

export const LanguageHandler = () => {
  useLanguageHandler();

  return null;
};
